import { createContext, useContext, useState } from "react";
import { createCartStore } from "../stores/cart-store";

type CartContextValue = ReturnType<typeof createCartStore>;

const CartContext = createContext<CartContextValue | null>(null);

type CartProviderProps = {
	hubId: string;
	children: React.ReactNode;
};

export const CartProvider = (props: CartProviderProps) => {
	const { hubId, children } = props;
	const [store] = useState(() => createCartStore(hubId));

	return <CartContext.Provider value={store}>{children}</CartContext.Provider>;
};

export const useCart = () => {
	const store = useContext(CartContext);
	if (!store) {
		throw new Error("useCart must be used within a CartProvider");
	}
	return store;
};
